import { useStore } from '@/store';
import { IFileListItem } from './file';
import { RequestKindTypes, RequestStatuses } from './request';

/**
 * 예약일, 예약시간, 의사, 주증상, 파일, 예약코멘트
 */
export interface IOnlineCarePurpose {
  date: String;
  time: String;
  doctorKey: Number | null;
  deptKey: Number | null;
  hospitalKey: Number | null;
  other: string;
  files: Array<IFileListItem> | null;
  //pharmacyKey: Number | null
  otherComment?: String;
}
export interface IOnlineCarePurposeQuick {
  other: string;
  files: Array<IFileListItem> | null;
  otherComment?: String;
}

export class OnlineCareCommon {
  public PID: string = '';
  public FacilityKey: number | null = null;
  public RequestKey: number | null = null;
  public CultureLangName = '';
  public RequestKind: RequestKindTypes | null = null;
  public RequestPurpose = '';
  public PurposeOthers = '';
  public SaveMode = 0;
  public RequestStatus: RequestStatuses = 0;
  public AppointmentType: number | null = null;
  //public HospitalKey: number | null = null;
  constructor() {
    //if (hospitalKey) this.HospitalKey = hospitalKey.valueOf() ?? null;
  }
}
/**
 * @see {@link OnlineCareCommon}
 */
export class OnlineCare extends OnlineCareCommon {
  public PurposeOthers = '';
  public DesiredDrKey: number | null = null;
  public DesiredDeptKey: number | null = null;
  public DesiredDateTime1: string = '';
  public PharmacyKey: number | null = null;
  public DesiredHospitalKey: number | null | undefined = null;

  constructor(data: {
    datetime: string;
    other: string;
    doctorkey: number;
    deptKey: number;
    requestKey: number;
    hospitalKey: number | undefined;
    appointmentType: number | undefined;
    //pharmacyKey: number | null;
    //hospitalKey: Number | null;
  }) {
    super();
    const accountInfo = useStore().getters.getAccountInfo;
    const appointType = useStore().getters.getAppointType;
    // const locale = useI18n().locale;
    if (!accountInfo) return;
    this.PID = accountInfo.PID;
    this.FacilityKey = accountInfo.FacilityKey;
    // this.CultureLangName = locale.value;

    this.AppointmentType = Number(appointType);
    if(data.appointmentType && data.appointmentType > 0) {
      this.AppointmentType = data.appointmentType;
    }
   
    this.RequestKind = RequestKindTypes.OnlineCare;
    this.DesiredDateTime1 = data.datetime;
    this.PurposeOthers = data.other;
    this.DesiredDrKey = data.doctorkey;
    this.DesiredDeptKey = data.deptKey;
    this.RequestKey = data.requestKey;
    this.DesiredHospitalKey = data.hospitalKey;
    //this.PharmacyKey = data.pharmacyKey;
  }
}

/**
 * @see {@link OnlineCareCommon}
 */
export class OnlineCareQuick extends OnlineCareCommon {
  constructor(data: { other: string; requestKey: number; hospitalKey: number | null }) {
    super();
    const accountInfo = useStore().getters.getAccountInfo;
    // const locale = useI18n().locale;
    if (!accountInfo) return;
    this.PID = accountInfo.PID;
    this.FacilityKey = accountInfo.FacilityKey;
    this.RequestKind = RequestKindTypes.OnlineCare;
    this.PurposeOthers = data.other;
    this.RequestKey = data.requestKey;
  }
}
